export const mapMedal = (length: number) => {
  const medal = ["", "Bronze", "Silver", "Gold"];
  return medal[length];
};
